import React from "react";

type TImageProps = React.ComponentPropsWithoutRef<"img"> & {
  containerClass?: string;
};

const UiImage = ({ containerClass, ...rest }: TImageProps) => {
  return (
    <div className={`select-none pointer-events-none ${containerClass} `}>
      <img
        {...rest}
        src={rest?.src}
        alt={rest.alt}
        className={rest.className}
        loading="lazy"
      />
    </div>
  );
};

export default UiImage;
